/* Confirmations à renouveler — DS-10 (Bible §20).
   The merchant side of the §20 re-acknowledgement triggers: guidance change,
   duplication, Destination replacement, timer/copy change, reactivation.
   Nothing stops abruptly — the campaign runs on its declared fallback while
   a confirmation is outstanding. */
import { Button, EmptyState, ErrorState, ListRow, Note, Pill } from '@/ui'
import { useAcks } from './api'
import { Chargement, Retour } from './parts'

export default function Confirmations() {
  const { data, isPending, isError, refetch } = useAcks()

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger vos confirmations."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  const pending = data.pending

  if (pending.length === 0) return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 620 }}>
      <Retour />
      <EmptyState title="Rien à re-confirmer."
        why="Une confirmation est demandée quand un guide change, qu’un lien d’avis est remplacé ou qu’une campagne est dupliquée. Aucune n’est en attente." />
    </div>
  )

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 720 }}>
      <Retour />
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <h2 className="t-page" style={{ margin: 0 }}>Confirmations à renouveler</h2>
        <span style={{ marginLeft: 'auto' }}>
          <Pill tone="warn">{pending.length} en attente</Pill>
        </span>
      </div>

      <section>
        {pending.map(a => (
          <ListRow key={a.id} title={a.title} meta={a.meta}
            end={<Button size="sm" variant={a.primary ? 'primary' : 'quiet'}>{a.action}</Button>} />
        ))}
      </section>

      <Note tone="ok">
        Tant qu’une confirmation manque, la campagne concernée continue de tourner sur son
        repli déclaré — rien ne s’arrête brutalement, et vous savez exactement quoi faire.
      </Note>
    </div>
  )
}
